import request from '../utils/request';
//var data = require("../default/data");
var poster = {
  create: ({ galleryid, imageids, border, desc }) => {
    return new Promise((resolve, reject) => {
      request({
        url: '/api/v2/userposter/create',
        method: 'post',
        data: {
          galleryid,
          imageids,
          border,
          desc
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  createv2: ({galleryid, imageids, thumb}) => {
    return new Promise((resolve, reject)=>{
      request({
        url:'/api/v2/userposter/createv2',
        method:'post',
        data:{
          galleryid,
          imageids,
          thumb
        },
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      }).then(resolve).catch(reject)
    });
  }
};

export default poster;
